<div class="container">
  <h1 class="main-title">Choose your plan</h1>
  <p class="sub-title">Select the perfect plan for your needs. Choose between our flexible credit system, unlimited render subscription, or team based plans.</p>
  <p-selectButton
    [options]="pricingOptions"
    [(ngModel)]="currentSelection"
    optionLabel="label"
    optionValue="value"
    [allowEmpty]="false"
  />
  <div class="line"> </div>
  @if (currentSelection === pricingEnum.Individual) {
    <h2 class="secondary-title">Pay As You Go Credits</h2>
    <p class="sub-title">Just getting started or only need occasional updates? The Credit system gives you precise control over your costs.</p>
    <div class="card-container">
      <!--@let costPerCredit = ((costPerCredit$ | async) ?? 0);-->
      @for(card of (creditCards$ | async); track card) {
        <p-card [class.popular]="card.popular">
          <div class="card-content">
            <i [class]="card.icon + ' icon'" [style.color]="'var(--primary-color)'"></i>
            <h1 class="title">{{card.amount}} Credits</h1>
            <p class="subtext">{{ card.subtext }} </p>
            <h1 class="price">{{card.price | currency:'USD'}}</h1>
            <p class="savings" [style.visibility]="card.showSavings ? 'visible' : 'hidden'">{{ (((card.amount * ((costPerCredit$ | async) ?? 0)) - card.price) / (card.amount * ((costPerCredit$ | async) ?? 0))) | percent }} Savings Per Render!</p>
            <p-button
              label="Purchase Credits"
              (onClick)="purchaseClicked(card.priceId, 'payment')"
              [loading]="clicked === card.priceId"
            >
            </p-button>
          </div>
        </p-card>
      }
    </div>
    <h2 class="secondary-title">Unlimited Access Subscriptions</h2>
    <p class="sub-title">Need frequent updates or large-scale rendering? The subscription model gives you unlimited renders as long as you're subscribed!</p>
    <div class="card-container">

    @for(card of (subscriptionCards$ | async); track card) {
      <p-card [class.popular]="card.popular">
        <div class="card-content">
          <i [class]="card.icon + ' icon'" [style.color]="'var(--primary-color)'"></i>
          <h1 class="title">{{card.billingCycle}} Subscription</h1>
          <p class="subtext">{{ card.subtext }} </p>
          <h1 class="price">{{card.price | currency:'USD'}}</h1>
          <p
            class="savings"
            [style.visibility]="card.showSavings ? 'visible' : 'hidden'"
          >
            {{ (((card.amount * ((costPerMonth$ | async) ?? 0)) - card.price) / (card.amount * ((costPerMonth$ | async) ?? 0))) | percent }} Savings!
          </p>
          <p-button
            label="Purchase "
            (onClick)="purchaseClicked(card.priceId, 'subscription')"
            [loading]="clicked === card.priceId"
          >
          </p-button>
        </div>
      </p-card>
    }
  </div>
}
@else {
    <h2 class="secondary-title">Team Plans</h2>
    <p class="sub-title">Real-time collaborative editing, organized folders, and simple seat management built for seamless teamwork.</p>
    <div class="card-container">
      <!--@let costPerCredit = ((costPerCredit$ | async) ?? 0);-->
      @for(card of (enterpriseCards$ | async); track card) {
        <p-card [class.popular]="card.popular">
          <div class="card-content">
            <i [class]="card.icon + ' icon'" [style.color]="'var(--primary-color)'"></i>
            <h1 class="title">{{card.amount}} Users</h1>
            <p class="subtext">{{ card.subtext }} </p>
            <h1 class="price">{{card.price | currency:'USD'}}</h1>
            <p class="savings" [style.visibility]="card.showSavings ? 'visible' : 'hidden'">
              {{ 1 - (card.price / (((baseCostPerTeamMember$ | async) ?? 0 ))) | percent }}
              Savings Per User!
            </p>
            <p-dropdown
              [(ngModel)]="teamSize[card.priceId]"
              [options]="card.teamSizeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Team Size"
            />
            <p-button
              label="Purchase Credits"
              (onClick)="purchaseEnterpriseClicked(card.priceId, 'subscription')"
              [loading]="clicked === card.priceId"
            >
            </p-button>
          </div>
        </p-card>
      }
    </div>
}
</div>
